export const renderClientOnlyLoaderToken = '_CLIENT_ONLY_LOADER_' as const;
